/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './actionTypes';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import _ from 'lodash';
import moment from 'moment';
const axiosPayLoad = {
  checkbox: [],
  dropdown: [],
  quarter: '',
  manufacturer: [],
  checkDetails: [],
  errorMessageInRedux: [],
  searchStatus: true,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_PLAN_TYPE_DATA:
      var updatedArray = [];
      if (action.checkbox) {
        var localAr = action.checkbox;
        if (localAr?.PLAN_TYPE_CD?.length > 0) {
          var planArray = localAr?.PLAN_TYPE_CD;
          planArray.forEach((element) => {
            if (element?.codeValueID?.codeValue == 'FD') {
              const indexOf = _.findIndex(planArray, element);

              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
              }
              localAr.PLAN_TYPE_CD = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        checkbox: localAr,
      };
    case actionTypes.GET_COMMON_DROPDOWN_DATA:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionTypes.GET_QUARTER_DATA:
      return {
        ...state,
        quarter: action.quarter,
      };
    case actionTypes.GET_MANUFACTURER_DATA:
      return {
        ...state,
        manufacturer: action.manufacturer,
      };
    case actionTypes.GET_CHECK_DETAILS:
      var checkDetailsObj = action?.checkDetails;
      if (checkDetailsObj) {
        if (checkDetailsObj?.data && checkDetailsObj?.data?.length > 0) {
          checkDetailsObj.data.forEach((element) => {
            if (element.batchDt) {
              element.batchDt = moment(element?.batchDt).format('MM/DD/YYYY');
            }
            if (element.checkDt) {
              element.checkDt = moment(element?.checkDt).format('MM/DD/YYYY');
            }
            if (element.postmarkedDt) {
              element.postmarkedDt = moment(element?.postmarkedDt).format(
                'MM/DD/YYYY'
              );
            }
            if (element.receivedDt) {
              element.receivedDt = moment(element?.receivedDt).format(
                'MM/DD/YYYY'
              );
            }
            if (element.insertedDt) {
              element.insertedDt = moment(element?.insertedDt).format(
                'MM/DD/YYYY'
              );
            }
            if (element.lastUpdateDt) {
              element.lastUpdateDt = moment(element?.lastUpdateDt).format(
                'MM/DD/YYYY'
              );
            }
            element.checkAmt = '$ ' + element?.checkAmt;
            element.totAllocatedAmt = '$ ' + element?.totAllocatedAmt;
          });
        }
      }
      return {
        ...state,
        checkDetails: checkDetailsObj,
      };
    case actionTypes.HANDLE_ERROR_MSG_CBI:
      return {
        ...state,
        errorMessageInRedux: action.errorMessageInRedux,
      };
    case actionTypes.SELECTED_REBATE_PROGRAM:
      return {
        ...state,
        selectedRebateProgram: action.selectedRebateProgram,
      };
    case actionTypes.QTR_VALUE:
      return {
        ...state,
        quarterInput: action.quarterInput,
      };
    case actionTypes.SEARCH_DISABLED:
      return {
        ...state,
        searchStatus: action.searchStatus,
      };
    case actionTypes.ROW_SELECTED:
      return {
        ...state,
        rowSelected: action.rowSelected,
      };
    case actionTypes.QTR_VALUE_FOR_API:
      return {
        ...state,
        quarterInAPI: action.quarterInAPI,
      };
    case actionTypes.CLEAR_REDUX:
      return [];
    default:
      return state;
  }
};

export default reducer;
